module.exports = __webpack_public_path__ + "static/media/cloud1.e2203a6a.png";